(function () {
    'use strict';

    var errorPattern = /Error:\s*190\b|Error validating access token|Session has expired/i;

    function hidePluginErrors(root) {
        var scope = root || document;
        var shorts = scope.querySelectorAll('.instagram-feed__shortcode');
        shorts.forEach(function (node) {
            if (node.dataset.igChecked === '1') {
                return;
            }
            var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
            if (!text || !errorPattern.test(text)) {
                return;
            }
            node.dataset.igChecked = '1';
            node.classList.add('instagram-feed__shortcode--plugin-error');
            node.setAttribute('hidden', 'hidden');
            node.innerHTML = '';

            var feed = node.closest('.instagram-feed');
            if (!feed || feed.querySelector('.instagram-feed__fallback')) {
                return;
            }
            var actions = feed.querySelector('.instagram-feed__actions');
            if (actions) {
                return;
            }
            var fallback = document.createElement('p');
            fallback.className = 'instagram-feed__fallback';
            fallback.textContent = '';
            node.parentNode.appendChild(fallback);
        });
    }

    function init() {
        hidePluginErrors(document);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    window.addEventListener('load', init);
})();
